export const currencies = {
  EUR: 'EUR',
  USD: 'USD'
}

export const currencyTextsConfig = {
  EUR: {
    1: {
      single: 'euro',
      plural: 'euros',
      special: 'de euros'
    },
    2: {
      single: 'euro',
      plural: 'euros',
      special: 'd\'euros'
    },
    3: {
      single: 'euro',
      plural: 'euros',
      special: 'de euros'
    },
    4: {
      single: 'euro',
      plural: 'euros',
      special: 'de euros'
    },
    5: {
      single: 'euro',
      plural: 'euros',
      special: 'de euros'
    }
  },
  USD: {
    1: {
      single: '',
      plural: '',
      special: ''
    },
    2: {
      single: '',
      plural: '',
      special: ''
    },
    3: {
      single: '',
      plural: '',
      special: ''
    },
    4: {
      single: '',
      plural: '',
      special: ''
    },
    5: {
      single: '',
      plural: '',
      special: ''
    }
  }
}

export const currencySymbol = {
  EUR: '€',
  USD: '$'
}

export const currencyMoneyFormat = {
  EUR: {
    format: {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 2
    },
    currency: 'es-ES'
  },
  USD: {
    format: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2
    },
    currency: 'en-US'
  }
}

export const icoCurrencyContent = {
  EUR: 'ico-planteo-economico',
  USD: 'ico-planteo-economico-usd'
}
